'use client';

import { useRouter } from '@/src/i18n/navigation';
import { useSearchStore } from '@/src/lib/state-stores/searchStore';
import { cn } from '@/src/lib/utils/command';
import { Routes } from '@/src/routes/routes';
import { Clock, ClockAlert, X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import Typography from '../ui/typography';

const SearchHistory = ({ setOpen }: { setOpen: (e: boolean) => void }) => {
  const t = useTranslations('dialog');
  const { clearSearchHistory, removeSearch, searchHistory } = useSearchStore();
  const router = useRouter();

  return (
    <div>
      {/* the heading  */}
      <div className="mx-2 my-3 flex items-center justify-between">
        <Typography
          variant={'body2'}
          weight={'semibold'}
          className="flex items-center gap-1"
          color={'text'}
        >
          <Clock className="h-4.5 w-4.5" />
          {t('PreviousSearch')}
        </Typography>
        <button
          onClick={clearSearchHistory}
          className="cursor-pointer text-sm font-bold transition-all duration-300 hover:tracking-wide"
        >
          {t('ClearAll')}
        </button>
      </div>

      {/* render list  of history search */}

      <div className="mt-4 flex flex-col">
        {searchHistory.map((search, index) => (
          <div
            key={index}
            className={cn(
              'flex cursor-pointer items-center justify-between rounded-sm px-3 hover:bg-gray-100',
              index !== searchHistory.length - 1 && 'border-secondary border-b',
            )}
          >
            <button
              onClick={() => {
                router.push({
                  pathname: Routes.search,
                  query: {
                    query: search,
                  },
                });
                setOpen(false);
              }}
              className="w-full cursor-pointer text-start capitalize"
            >
              {search}
            </button>
            <button
              onClick={() => {
                removeSearch(search);
              }}
              className="cursor-pointer p-3"
            >
              <X className="h-4.5 w-4.5 text-gray-600" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchHistory;
